import { Divider } from "react-native-paper";
import Box from "../Box";
import { FlatCard } from "../Cards/FlatCard";
import { Skeleton } from "../Skeleton";

const HEADER_MIN_HEIGHT = 72;
const AVATAR_SIZE = 40;
const TITLE_LINE_HEIGHT = 24;
const BODY_LINE_HEIGHT = 20;
const LABEL_LINE_HEIGHT = 16;
const CONTENT_LINE_WIDTHS = ["100%", "85%", "60%"] as const;

type Props = {
	titleWidth?: `${number}%`;
	numContentLines?: number;
};

const TextLine = ({
	lineHeight,
	barHeight,
	width,
}: {
	lineHeight: number;
	barHeight: number;
	width: number | `${number}%`;
}) => (
	<Box height={lineHeight} justifyContent="center">
		<Skeleton width={width} height={barHeight} />
	</Box>
);

export const CardContainerSkeleton = ({
	titleWidth = "60%",
	numContentLines = 3,
}: Props) => (
	<FlatCard style={{ overflow: "hidden" }}>
		<Box
			flexDirection="row"
			alignItems="center"
			minHeight={HEADER_MIN_HEIGHT}
			paddingHorizontal={16}
			paddingVertical={16}
			gap={16}
		>
			<Skeleton size={AVATAR_SIZE} variant="circle" />
			<Box flex={1} gap={2}>
				<TextLine
					lineHeight={TITLE_LINE_HEIGHT}
					barHeight={16}
					width={titleWidth}
				/>
				<TextLine lineHeight={LABEL_LINE_HEIGHT} barHeight={12} width="45%" />
			</Box>
		</Box>
		<Divider />
		<Box padding={16} gap={12}>
			{Array.from({ length: numContentLines }).map((_, lineIndex) => (
				<TextLine
					// biome-ignore lint/suspicious/noArrayIndexKey: static skeleton lines
					key={lineIndex}
					lineHeight={BODY_LINE_HEIGHT}
					barHeight={14}
					width={CONTENT_LINE_WIDTHS[lineIndex % CONTENT_LINE_WIDTHS.length]}
				/>
			))}
		</Box>
	</FlatCard>
);
